import { render, staticRenderFns } from "./DashboardOvertimeLimit.vue?vue&type=template&id=d0fac16e&"
import script from "./DashboardOvertimeLimit.vue?vue&type=script&lang=js&"
export * from "./DashboardOvertimeLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports